import { Type, TemplateRef } from "@angular/core"

export interface ModalOptions {
  layoutColor: string | undefined
  backgroundColor: string | undefined
  cssClass: string | string[] | undefined
  padding: string | number | [number, number] | [number, number, number] | [number, number, number, number] | undefined
  width: number | undefined
  height: number | undefined
  minWidth: number | undefined
  minHeight: number | undefined
  maxWidth: number | undefined
  maxHeight: number | undefined
  showClose: boolean
  fullscreen: boolean
  destroyOnLayoutClick: boolean
}

export const defaultModalOptions: ModalOptions = {
  layoutColor: undefined,
  backgroundColor: undefined,
  cssClass: undefined,
  padding: undefined,
  width: undefined,
  height: undefined,
  minWidth: undefined,
  minHeight: undefined,
  maxWidth: undefined,
  maxHeight: undefined,
  showClose: true,
  fullscreen: false,
  destroyOnLayoutClick: true,
}

export type ModalContent = Type<unknown>|TemplateRef<unknown>|string

export interface ModalInputs {
  [key: string]: unknown
  id: number
  content: ModalContent
  options: ModalOptions
  data: Record<string, unknown>
}

export interface ModalEvent {
  show: boolean
}
